import React from 'react'
import { AppPrimaryButton, AppButton } from 'elements'
import { EmptyState } from './consolidated-report-email-styles'
import { formatFireWhen } from './consolidated-report-email-utils'

export const NoSchedulesEmpty = ({ onCreate }) => (
    <EmptyState>
        <div className="icon">📬</div>
        <h3>No consolidated report emails yet</h3>
        <p>
            Create a schedule to bundle completed audit reports and email them to
            your team on a recurring basis. Weekly or monthly cadence, pick which
            templates and auditors to include, and pick the recipients.
        </p>
        <AppPrimaryButton onClick={onCreate}>
            + Create your first schedule
        </AppPrimaryButton>
    </EmptyState>
)

export const NoRunsEmpty = ({ nextFire }) => (
    <EmptyState>
        <div className="icon">📜</div>
        <h3>No fires yet</h3>
        <p>
            The first scheduled fire for your active schedules will land here.
            {nextFire && (
                <>
                    {' '}
                    Next fire: <strong>{formatFireWhen(nextFire.utc, nextFire.timezone)}</strong>{' '}
                    ({nextFire.name}).
                </>
            )}
        </p>
    </EmptyState>
)

export const NoSearchResultsEmpty = ({ query, onClear }) => (
    <EmptyState>
        <div className="icon">🔍</div>
        <h3>No schedules match &quot;{query}&quot;</h3>
        <p>Try a shorter search term, or clear the filters.</p>
        <AppButton onClick={onClear}>Clear filters</AppButton>
    </EmptyState>
)
